import React from 'react';
import ProductToolkitsCard from '../../../components/Cards/product-toolkit-card/product-toolkit-card';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import { GetHomePageProductToolkits } from '../../../api/home';
import { useQuery } from '@tanstack/react-query';
import { useUser } from 'context/UserContext';
import './product-toolkits.scss';

export default function ProductToolkits() {
  const user = useUser();

  function formatUserProducts() {
    var userProducts = '';
    for (const product of user.LOB) {
      userProducts += '' + product.ProductCode + ',';
    }
    return userProducts;
  }

  const getPoductToolkitsQuery = useQuery({
    queryKey: ['getHomePageProductToolkits'],
    queryFn: async () =>
      JSON.parse(
        await GetHomePageProductToolkits({
          division: user.division,
          product: formatUserProducts(),
        })()
      ),
  });

  if (getPoductToolkitsQuery.isLoading) return <LoadingIndicator />;

  if (
    getPoductToolkitsQuery.isSuccess &&
    Array.isArray(getPoductToolkitsQuery.data) &&
    getPoductToolkitsQuery.data.length > 0
  ) {
    return (
      <div className="ProductToolkitsCardsContainer">
        {getPoductToolkitsQuery.data.map((productToolkit, index) => {
          if (productToolkit.AppPackageLink && productToolkit.AppPackageLink.charAt(0) === '[') {
            productToolkit.AppPackageLink = JSON.parse(productToolkit.AppPackageLink)[0].url;
          }
          return (
            <div className="ProductToolkitsCard" key={index + 'product-toolkits-card'}>
              <ProductToolkitsCard data={productToolkit} />
            </div>
          );
        })}
      </div>
    );
  }

  return <></>;
}
